import React from "react";
import { Navigate } from "react-router-dom";
import { PulseLoader } from "react-spinners";
import { useUserContext } from "../utils/hooks/UserContext";
import { useTokenValidation } from "../utils/hooks/useTokenValidation";

const GuestRoute = ({ children }) => {
  const { isLoading, user } = useUserContext();
  const { isTokenValid } = useTokenValidation();

  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          width: "100vw",
        }}
      >
        <p>
          <PulseLoader color="#00504E" size={20} />
        </p>
      </div>
    );
  }

  if (user && isTokenValid()) {
    const redirectPath =
      user?.userType === "coach" ? "/coach/profile" : "/user/profile";
    return <Navigate to={redirectPath} replace />;
  }

  return children;
};

export default GuestRoute;
